export const DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE';

export const deleteDocumentFailure = error => ({
    type: DELETE_DOCUMENT_FAILURE,
    payload: error,
    error: true,
});
